
<template>
  	<LayoutView/>
</template>

<!-- // // // //  -->

<script>
import LayoutView from './components/layout.vue'

export default {
  name: 'auth_register',
  components: {
    LayoutView
  },
  metaInfo: {
    title: 'Auth - Register'
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/auth_register/index.vue